import { handleActions } from "redux-actions";
import { Map } from "immutable";

// Action Type Imports
import { constants as SponsorsDashboardConstants } from "../actions/dashboard-sponsors-actions";

// Events's Reducer
export const reducers = {
    [SponsorsDashboardConstants.SET_SPONSORS_DASHBOARD]: (state, { payload }) => {
        return state.merge({ sponsorDasboardAcces: payload.sponsors });
    },
    [SponsorsDashboardConstants.SET_SPONSORS_DASHBOARDSEGMENT]: (state, { payload }) => {
        let das = state.get("dashboards")
        return state.merge({ dashboards: {
            ...(das || {}),
            [payload.sponsors.id]: {
                ...((das || {})[payload.sponsors.id] || {}),
                [payload.sponsors.cases]: payload.sponsors.obj
            }
        }});
    },
};

export const initialState = () =>
    Map({
        sponsorDasboardAcces: [],
        dashboards: {},
    });

export default handleActions(reducers, initialState());
